<div class="footer-reco" data-print-block>
  <div class="footer-reco__inner">
    <div class="footer-reco__wash" aria-hidden="true"></div>
    <div class="footer-reco__body">
      <span class="footer-reco__icon"><svg class="icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="m9 14 2 2 4-4"/></svg></span>
      <div class="footer-reco__text">
        <h2 class="footer-reco__title">{{ 'footer.title' | reportT }}</h2>
        <p class="footer-reco__message">{{ 'footer.improvementPlan' | reportT }}</p>
        <div class="footer-reco__meta">
          <span class="footer-reco__confidential">
            <svg class="icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg><span>{{ 'footer.confidential' | reportT }}</span>
          </span>
          <span>{{ 'footer.generated' | reportT: { date: (view().generatedAt | reportFmt: 'datetime') } }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
